import gql from "graphql-tag";

const LIST_PARAMETER_FRAGMENT = gql`
  fragment ListParameterFragment on QuestionnaireListParameter {
    type
    label
    answered
    value
    children {
      label
      value
    }
  }
`

const CHILD_PARAMETER_FRAGMENT = gql`
  fragment ChildParameterItem on QuestionnaireTreeParameter {
    label
    selectable
    value
    children {
      ... on QuestionnaireParameterItem {
        label
        value
      }
    }
  }
`

const TREE_PARAMETER_FRAGMENT = gql`
  fragment TreeParameterFragment on QuestionnaireTreeParameter {
    type
    answered
    chosenOptionId
    ...ChildParameterItem
    children {
      ... on QuestionnaireTreeParameter {
        ...ChildParameterItem
        children {
          ...ChildParameterItem
          ... on QuestionnaireTreeParameter {
            ...ChildParameterItem
            children {
              ...ChildParameterItem
              ... on QuestionnaireTreeParameter {
                ...ChildParameterItem
                children {
                  ...ChildParameterItem
                  ... on QuestionnaireTreeParameter {
                    ...ChildParameterItem
                    children {
                      ...ChildParameterItem
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${CHILD_PARAMETER_FRAGMENT}
`

const MEDIA_FRAGMENT = gql`
  fragment MediaFragment on SurveyMedia {
    id
    title
    type
    details {
      key
    }
  }
`

const CATALYST_FRAGMENT = gql`
  fragment CatalystFragment on QuestionnaireCatalyst {
    id
    title
    description
    drivers {
      id
      title
      description
      affectingQuestionIds
    }
    questions {
      id
      title
      subTitle
      lowEndLabel
      highEndLabel
      availability {
        acceptableParameterOptionIds
      }
      answered
      skipped
      response
      rate
    }
    openQuestions {
      id
      title
      availability {
        acceptableParameterOptionIds
      }
      response
      public
      answered
      skipped
    }
  }
`

export const QUESTIONNAIRE_FRAGMENT = gql`
  fragment QuestionnaireFragment on Questionnaire {
    id
    isFinished
    canChooseParameterOptions
    isDialogueActive
    areProgressReportsActive
    canGoToQuestions
    canComment
    canViewAfterGame
    canAnswer
    isFinished
    isConsented
    isAfterGameGuest
    hideCatalystThemePages
    languages
    logo {
      key
    }
    media {
      ...MediaFragment
    }
    catalysts {
      ...CatalystFragment
    }
    parameters {
      ...ListParameterFragment
      ...TreeParameterFragment
    }
    surveySequence {
      id
      title
      identifier
      state
      youResponded
      currentlyViewing
    }
  }
  ${MEDIA_FRAGMENT}
  ${CATALYST_FRAGMENT}
  ${LIST_PARAMETER_FRAGMENT}
  ${TREE_PARAMETER_FRAGMENT}
`;

const SURVEY_LIST_CHILD_PARAMETER_FRAGMENT = gql`
  fragment ParameterChild on SurveyTreeParameter {
    label
    value
    children {
      ... on SurveyParameterItem {
        label
        value
      }
    }
  }
`

export const SURVEY_LIST_PARAMETER_FRAGMENT = gql`
  fragment SurveyListParameter on SurveyListParameter {
    type
    label
    value
    children {
      label
      value
    }
  }
`

export const SURVEY_TREE_PARAMETER_FRAGMENT = gql`
  fragment SurveyTreeParameter on SurveyTreeParameter {
    ...ParameterChild
    children {
      ... on SurveyTreeParameter {
        ...ParameterChild
        children {
          ...ParameterChild
          ... on SurveyTreeParameter {
            ...ParameterChild
            children {
              ...ParameterChild
              ... on SurveyTreeParameter {
                ...ParameterChild
                children {
                  ...ParameterChild
                  ... on SurveyTreeParameter {
                    ...ParameterChild
                    children {
                      ...ParameterChild
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${SURVEY_LIST_CHILD_PARAMETER_FRAGMENT}
`





// WEBPACK FOOTER //
// ./src/graphql/fragments.js